import React from 'react';
import { Admin, Resource } from 'react-admin';
import authProvider from './lib/authProvider';
import dataProvider from './lib/dataProvider';
import Layout from './resources/Layout';
import UserList from './resources/users/UserList';
import UserShow from './resources/users/show/UserShow';
import SubscriptionEdit from './resources/subscriptions/SubscriptionEdit';
import SubscriptionCreate from './resources/subscriptions/SubscriptionCreate';
import PromoList from './resources/promos/PromoList';
import PromoShow from './resources/promos/PromoShow';
import PromoCreate from './resources/promos/PromoCreate';
import PromoEdit from './resources/promos/PromoEdit';
import NotificationList from './resources/notifications/NotificationList';
import NotificationCreate from './resources/notifications/NotificationCreate';
import ExerciseList from './resources/exercises/ExerciseList';
import ExerciseShow from './resources/exercises/ExerciseShow';
import CommentList from './resources/comments/CommentList';
import PlanShow from './resources/plans/PlanShow';
import TagList from './resources/tags/TagList';
import TagEdit from './resources/tags/TagEdit';
import CustomRoutes from './resources/custom-routes/CustomRoutes';

const App = () => (
  <Admin
    customRoutes={CustomRoutes}
    title="Mistercalcio admin"
    authProvider={authProvider}
    dataProvider={dataProvider}
    appLayout={Layout}
  >
    <Resource name="users" list={UserList} show={UserShow} />
    <Resource name="users/login_history" />
    <Resource name="subscriptions" edit={SubscriptionEdit} create={SubscriptionCreate} />
    <Resource name="promos" list={PromoList} show={PromoShow} create={PromoCreate} edit={PromoEdit} />
    <Resource name="plans" show={PlanShow} />
    <Resource name="companies" />
    <Resource name="notifications" list={NotificationList} create={NotificationCreate} />
    <Resource name="exercises" list={ExerciseList} show={ExerciseShow} />
    <Resource name="comments" list={CommentList} />
    <Resource name="tags" list={TagList} edit={TagEdit} />
    <Resource name="objectives" />
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx